import React from 'react';
import MainContainer from '../../components/MainContainer';
import { headerDataImmo } from '../../data/modules/logistic-header';
import { Grid } from '@mui/material';
import VehicleTable from './VehicleTable';
import { useNavigate } from 'react-router';
import { makeStyles } from "@material-ui/core/styles";

const VehicleList = () => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
      <MainContainer {...headerDataImmo}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
            <VehicleTable />
        </Grid>
      </Grid>
        </MainContainer>
        </React.Fragment>
    );
    }

export default VehicleList;